<template>
    <section class="searchSection">
        <QuestionSubmissionForm :product-id="productId" />
        <TheButton v-if="productId" class="help__button" :title="$t('discussions.button')" @click="openQuestionSubmissionModal" />
        <WatchDog v-if="productId" :product-id="productId" />
        <SearchByQueries :posts="posts" />
    </section>
</template>

<script lang="ts">
import { PropType } from 'vue'
import DiscussionPost from '~/models/DiscussionPost'
import WatchDog from '~/components/objects/Discussion/Tools/WatchDog.vue'
import SearchByQueries from '~/components/objects/Discussion/Tools/SearchByQueries.vue'
import TheButton from '~/components/ui/TheButton.vue'
import QuestionSubmissionForm from '~/components/objects/Discussion/Modals/QuestionSubmissionForm.vue'
import { useBasketStore } from '~/stores/basket'

export default {
    components: {
        SearchByQueries,
        WatchDog,
        TheButton,
        QuestionSubmissionForm,
    },

    props: {
        productId: {
            type: Number,
            default: null,
        },
        categoryId: {
            type: Number,
            default: null,
        },
        posts: {
            type: [] as PropType<DiscussionPost[]>,
            required: true,
        },
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()
            return basketStore.authUser
        },
        isUserAuthenticated() {
            return this.authUser !== null
        },
    },
    methods: {
        openQuestionSubmissionModal() {
            if (this.isUserAuthenticated) {
                useNuxtApp().$bus.$emit('showModal', 'question-submission-form')
            } else {
                useNuxtApp().$bus.$emit('openModalForLogin')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.searchSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
</style>
